import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealsComponent } from './deals.component';
import { AuthGuard } from 'src/app/core/auth/guards/auth.guard';
import { AddEditcommonProductComponent } from 'src/app/shared/common-product/add-editcommon-product/add-editcommon-product.component';
import { AddEditdealsComponent } from './add-editdeals/add-editdeals.component';
import { DealsImportComponent } from './deals-import/deals-import.component';
import { DealsAdvanceXlComponent } from './deals-advance-xl/deals-advance-xl.component';
import { DealEditPageComponent } from './deal-edit-page/deal-edit-page.component';

const routes: Routes = [{ path: '', component: DealsComponent },
{
  path: 'adddeals/:dealId',
  component: AddEditdealsComponent,
  canActivate: [AuthGuard]
},
{
  path: 'deal-edit/:leadId',
  component: DealEditPageComponent,
  canActivate: [AuthGuard]
},
{
  path: 'deal-detail/:leadId',
  component: DealEditPageComponent,
  canActivate: [AuthGuard]
},

{
  path: 'add-edit-deals/:dealId/:setId',
  component: AddEditdealsComponent,
  canActivate: [AuthGuard]
},

{
  path: 'add-edit-deals-company/:dealId/:setId',
  component: AddEditdealsComponent,
  canActivate: [AuthGuard]
},

{
  path: 'xlMapper',
  component: DealsAdvanceXlComponent,
  canActivate: [AuthGuard]
},

{
  path: 'add-edit-deals/:dealId/:setId',
  component: AddEditcommonProductComponent,
  canActivate: [AuthGuard]
},
{
  path: 'import-deals',
  component: DealsImportComponent,
  canActivate: [AuthGuard]
},

{
  path: 'export-deals',
  component: DealsImportComponent,
  canActivate: [AuthGuard]
},
{
  path: 'add-edit-deals/:dealId/:setId/:leadId',
  component: AddEditdealsComponent,
  canActivate: [AuthGuard]
},

{
  path: 'add-edit-deals/:dealId/:setId/:leadId',
  component: AddEditcommonProductComponent,
  canActivate: [AuthGuard]
},
{
  path: 'add-edit-deals-company/:dealId/:setId/:leadId',
  component: AddEditdealsComponent,
  canActivate: [AuthGuard]
},
{
  path: 'add-edit-deals/:dealId/:setId/:leadId/:companyId',
  component: AddEditdealsComponent,
  canActivate: [AuthGuard]
},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealsRoutingModule { }
